import { DateTimeService, DateTimeUtils, useAppClockService, useTimezone } from '@mews/framework';
import { getAppDateTimeNow, useCommanderSelector } from '@mews-commander/utils';
import { getServiceEnterpriseEditableHistoryIntervalMilliseconds } from '@mews-commander/legacy-entities/src/selectors/services';

export const useIntervalAdjustmentFormMinDate = (serviceId: String) => {
    const timezone = useTimezone();
    const appClockService = useAppClockService();

    const intervalMilliseconds = useCommanderSelector((state) =>
        getServiceEnterpriseEditableHistoryIntervalMilliseconds(state, { serviceId })
    );

    const now = getAppDateTimeNow({ appClockService, timezone });

    return DateTimeUtils.dateTimeToStructuredDate(DateTimeService.addMilliseconds(now, -intervalMilliseconds));
};
